/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    id: 1,
    label: 'Email',
    field_name: 'email',
    source_field: 'email',
    customClass: 'email',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'First Name',
    field_name: 'first_name',
    source_field: 'first_name',
    showColumn: true,
  },
  {
    id: 3,
    label: 'Last Name',
    field_name: 'last_name',
    source_field: 'last_name',
    showColumn: true,
  },
  {
    id: 4,
    label: 'Group name',
    field_name: 'group_name',
    source_field: 'group_name',
    showColumn: true,
  },
  {
    id: 5,
    label: 'VPA #',
    field_name: 'user_vpa_order',
    source_field: 'user_vpa_order',
    showColumn: true,
  },
  {
    id: 6,
    label: 'Date of test start',
    field_name: 'started_at',
    source_field: 'started_at',
    showColumn: true,
  },
  {
    id: 7,
    label: 'Date of test complete',
    field_name: 'completed_at',
    source_field: 'completed_at',
    showColumn: true,
  },
  {
    id: 8,
    label: 'VPA Level',
    field_name: 'overall_level',
    source_field: 'overall_level',
    showColumn: true,
    align: 'center',
  },
  {
    id: 9,
    label: 'VPA Overall Score',
    field_name: 'overall_score',
    source_field: 'overall_score',
    showColumn: true,
    align: 'center',
  },
  {
    id: 10,
    label: 'Reading Score',
    field_name: 'reading_score',
    source_field: 'reading_score',
    showColumn: true,
  },
  {
    id: 11,
    label: 'Reading Level',
    field_name: 'reading_level',
    source_field: 'reading_level',
    showColumn: true,
  },
  {
    id: 12,
    label: 'Grammar Score',
    field_name: 'grammar_score',
    source_field: 'grammar_score',
    showColumn: true,
  },
  {
    id: 13,
    label: 'Grammar Level',
    field_name: 'grammar_level',
    source_field: 'grammar_level',
    showColumn: true,
  },
  {
    id: 14,
    label: 'Listening Score',
    field_name: 'listening_score',
    source_field: 'listening_score',
    showColumn: true,
  },
  {
    id: 15,
    label: 'Listening Level',
    field_name: 'listening_level',
    source_field: 'listening_level',
    showColumn: true,
  },
  {
    id: 16,
    label: 'Speaking Score',
    field_name: 'speaking_score',
    source_field: 'speaking_score',
    showColumn: true,
  },
  {
    id: 17,
    label: 'Speaking Level',
    field_name: 'speaking_level',
    source_field: 'speaking_level',
    showColumn: true,
  },
  {
    id: 18,
    label: 'Total time spent on test (minutes)',
    field_name: 'total_time_spent_on_test',
    source_field: 'total_time_spent_on_test',
    showColumn: true,
  },
  {
    id: 19,
    label: 'OPT Status',
    field_name: 'opt_reset',
    source_field: 'opt_reset',
    showColumn: false,
  },
];
